const SEND_OPTIONS = { suppressGlobalError: true };

export async function sendFirstDirectChatMessage(api, formData) {
  let response = await api.post("/chats/direct/open-or-create/", formData, SEND_OPTIONS);
  const chatId = Number(response?.data?.direct_chat_id || response?.data?.chat_id || 0);
  if (!Number.isFinite(chatId) || chatId <= 0) {
    throw new Error("direct_chat_id_missing");
  }

  const baseUrl = `/chats/direct/${encodeURIComponent(String(chatId))}`;
  if (!Object.prototype.hasOwnProperty.call(response?.data || {}, "message")) {
    // Older servers create the chat but ignore send_first_message. Newer
    // servers always include a message key, so do not risk sending twice if
    // their response is incomplete.
    response = await api.post(`${baseUrl}/messages/send/`, formData, SEND_OPTIONS);
  }

  if (Number(response?.data?.message?.id || 0) <= 0) {
    throw new Error("direct_chat_first_message_missing");
  }
  return { response, chatId, baseUrl };
}
